import useI18n from '@app/shared/vue/composables/use-I18n'

import type { Segment } from '@app/insights/types'

export function openDeleteSegmentConfirmation(segment: Segment): void {
  const I18n = useI18n()
  const { id, name, insight_triggers_count: triggersCount, partner } = segment

  const title = partner
    ? I18n.t('companies_overview.segments_new.deactivate_query')
    : I18n.t('companies_overview.segments_new.delete_query')

  const message = partner
    ? I18n.t('companies_overview.segments_new.confirm_deactivate_query', {
        name,
      })
    : I18n.t('companies_overview.segments_new.confirm_delete_query', { name })

  const firmSegmentHint =
    triggersCount > 0
      ? I18n.t('companies_overview.segments_new.delete_query_with_triggers', {
          href: window.Silverfin.Routes.insight_triggers_path(
            window.Silverfin.currentFirmId
          ),
          count: triggersCount,
        })
      : undefined

  const simpleHint = I18n.t(
    'companies_overview.segments_new.deactivate_query_hint'
  )
  const hint = partner
    ? [simpleHint, firmSegmentHint].filter(Boolean).join('<br />')
    : firmSegmentHint

  window.modalCitizen.openModalPortal('confirm-delete-segment-modal', {
    id,
    title,
    message,
    hint,
  })
}
